import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "components/common";
import ForwarderRoutes from "../../Routes";
const ForwarderCell = ({ forwarderId = void 0, forwarderTitle = void 0 }) => {
  const { t } = useTranslation("enterprise_forwarder");
  if (!forwarderId) {
    return /* @__PURE__ */ React.createElement("em", null, t("forwarder_cell.no_forwarder"));
  }
  return /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.details(forwarderId) }, forwarderTitle || forwarderId);
};
export default ForwarderCell;
